/**
 * @generated SignedSource<<34a808c017059d1c977e5990036e28c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduleItemTypeInput = {
  assignee?: string | null | undefined;
  bond_ee?: string | null | undefined;
  bond_es?: string | null | undefined;
  bond_left?: string | null | undefined;
  bond_parent_ee?: string | null | undefined;
  bond_parent_es?: string | null | undefined;
  bond_parent_se?: string | null | undefined;
  bond_parent_ss?: string | null | undefined;
  bond_right?: string | null | undefined;
  bond_se?: string | null | undefined;
  bond_ss?: string | null | undefined;
  children?: string | null | undefined;
  color?: string | null | undefined;
  completion_percentage?: number | null | undefined;
  contract_invoice?: string | null | undefined;
  cost_code_id?: number | null | undefined;
  count_days?: number | null | undefined;
  count_hours?: number | null | undefined;
  count_material?: number | null | undefined;
  count_people?: number | null | undefined;
  count_tools?: number | null | undefined;
  description?: string | null | undefined;
  division_id?: number | null | undefined;
  end_datetime?: string | null | undefined;
  equipment_hours?: number | null | undefined;
  id?: string | null | undefined;
  index_order?: number | null | undefined;
  material_hours?: number | null | undefined;
  name: string;
  number_wbs?: string | null | undefined;
  owner_item_id?: string | null | undefined;
  parent_id?: string | null | undefined;
  phase_id?: number | null | undefined;
  priority?: number | null | undefined;
  project_id?: string | null | undefined;
  role_item: string;
  start_datetime?: string | null | undefined;
  status?: number | null | undefined;
  type?: number | null | undefined;
  value_equipment?: number | null | undefined;
  value_labour?: number | null | undefined;
  value_material?: number | null | undefined;
  value_other?: number | null | undefined;
  value_total?: number | null | undefined;
  wo_si?: string | null | undefined;
};
export type UpdateBulkScheduleItemMutation$variables = {
  input?: ReadonlyArray<ScheduleItemTypeInput> | null | undefined;
};
export type UpdateBulkScheduleItemMutation$data = {
  readonly updateBulkScheduleItem: ReadonlyArray<{
    readonly id: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ScheduleItemForMutationFragment">;
  } | null | undefined> | null | undefined;
};
export type UpdateBulkScheduleItemMutation = {
  response: UpdateBulkScheduleItemMutation$data;
  variables: UpdateBulkScheduleItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateBulkScheduleItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleItem",
        "kind": "LinkedField",
        "name": "updateBulkScheduleItem",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ScheduleItemForMutationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateBulkScheduleItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleItem",
        "kind": "LinkedField",
        "name": "updateBulkScheduleItem",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "start_datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "end_datetime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_left",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_right",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_parent_ss",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_parent_se",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_parent_es",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_parent_ee",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_ss",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_se",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_es",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bond_ee",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completion_percentage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cost_code_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number_wbs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "project_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "owner_item_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phase_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "division_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parent_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "children",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role_item",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contract_invoice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count_hours",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count_days",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count_people",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "equipment_hours",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count_tools",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count_material",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "material_hours",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_equipment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_labour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wo_si",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_material",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_other",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value_total",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignee",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "765f2940ccbb2beb7f577d5c51562dce",
    "id": null,
    "metadata": {},
    "name": "UpdateBulkScheduleItemMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateBulkScheduleItemMutation(\n  $input: [ScheduleItemTypeInput!]\n) {\n  updateBulkScheduleItem(input: $input) {\n    id\n    ...ScheduleItemForMutationFragment\n  }\n}\n\nfragment ScheduleItemForMutationFragment on ScheduleItem {\n  id\n  name\n  start_datetime\n  end_datetime\n  status\n  color\n  type\n  bond_left\n  bond_right\n  bond_parent_ss\n  bond_parent_se\n  bond_parent_es\n  bond_parent_ee\n  bond_ss\n  bond_se\n  bond_es\n  bond_ee\n  completion_percentage\n  cost_code_id\n  number_wbs\n  project_id\n  owner_item_id\n  phase_id\n  division_id\n  description\n  parent_id\n  children\n  role_item\n  contract_invoice\n  count_hours\n  count_days\n  count_people\n  equipment_hours\n  count_tools\n  count_material\n  material_hours\n  priority\n  value_equipment\n  value_labour\n  wo_si\n  value_material\n  value_other\n  value_total\n  assignee\n}\n"
  }
};
})();

(node as any).hash = "442336a5221509fda719d9573d981c73";

export default node;
